import React, { Component } from 'react'
import { Modal, Checkbox, message } from 'antd';
const CheckboxGroup = Checkbox.Group;

const siteOptions = [
    { label: '项目指标分析（按区域）', value: 'AREA'},
    { label: '项目指标分析（按城市）', value: 'CITY'},
    { label: '项目指标分析（中心层面）', value: 'DETAIL'},
]

const projectOptions = [
    { label: '项目指标分析（项目层面）明细数据', value: 'DETAIL'},
    { label: '项目指标分析（按项目领域）', value: 'PROJECT_AREA'},
    { label: '项目指标分析（按疾病）', value: 'SICKNESS'},
]

export default class ExportModal extends Component {
    state = {
        visible: false,
        value: [],
        type: null,
        Options:[]
    }

    show = (type,params) => {
        this.setState({ 
            visible: true, 
            type, 
            Options : params.statisticalRange == 'SITE' ? siteOptions : projectOptions
        })
    }

    handleOk = () => {
        const { value, type } = this.state;
        if(value.length) {
            console.log(value);
            this.props.export( type, value);
            this.handleCancel()
        } else {
            message.warning('请选择导出内容')
        }
    }

    handleCancel = () => {
        this.setState({ 
            visible: false,
            value: [],
            type: null,
        })
    }

    onChange = value => {
        this.setState({ value })
    }

    render() {
        const { visible, value, Options } = this.state;
        return (
        <Modal
            title="明细导出"
            visible={visible}
            onOk={this.handleOk}
            width={450}
            onCancel={this.handleCancel}
        >
            <div style={{ width: '240px', margin: '10px 30px', lineHeight: '30px'}}>
                    <div className='title'>请选择导出内容</div>
                    <CheckboxGroup  
                        value={value} 
                        options={Options} 
                        onChange={this.onChange}
                    />
                </div>
        </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/homePage/projectIndicatorAnalysis/components/ExportModal.js